import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const TimeIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        d="M45.1417143,43.424 C45.1417143,43.5028571 45.1234286,43.5771429 45.1177143,43.656 C45.1108571,43.7965714 45.0994286,43.9348571 45.0765714,44.0742857 C45.056,44.2022857 45.0251429,44.3257143 44.9931429,44.448 C44.96,44.5737143 44.9245714,44.6971429 44.8788571,44.8182857 C44.832,44.9417143 44.7805714,45.0582857 44.7222857,45.1748571 C44.6662857,45.2902857 44.6057143,45.4034286 44.5382857,45.5142857 C44.4697143,45.6251429 44.3954286,45.7302857 44.3154286,45.8331429 C44.2388571,45.9348571 44.16,46.0342857 44.072,46.1291429 C43.976,46.2331429 43.8754286,46.3257143 43.7691429,46.4182857 C43.7097143,46.4708571 43.6628571,46.5314286 43.5988571,46.5805714 L31.6537143,55.8788571 C30.9234286,56.448 30.0582857,56.7234286 29.1988571,56.7234286 C28.008,56.7234286 26.8297143,56.1931429 26.04,55.1805714 C24.6834286,53.4365714 24.9954286,50.9234286 26.7382857,49.5668571 L37.1417143,41.4685714 L37.1417143,20.5554286 C37.1417143,18.3462857 38.9325714,16.5554286 41.1417143,16.5554286 C43.3508571,16.5554286 45.1417143,18.3462857 45.1417143,20.5554286 L45.1417143,43.424 Z M40,0 C17.9428571,0 0,17.9451429 0,40 C0,62.0571429 17.9428571,80 40,80 C62.056,80 80,62.0571429 80,40 C80,17.9451429 62.056,0 40,0 Z"
      />
    </Icon>
  );
};

TimeIcon.propTypes = {
  fill: PropTypes.string,
};

export default TimeIcon;
